"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ShipStationOrderItem = function ShipStationOrderItem() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, ShipStationOrderItem);

  this.name = params.name || '';
  this.sku = params.sku || '';
  this.imageUrl = params.imageUrl || '';
  this.unitPrice = parseFloat(params.unitPrice, 10) || 0;
  this.quantity = params.quantity || 1;
  this.weight = params.weight || null;
};

module.exports = ShipStationOrderItem;